import { Bill, ToBillArguments, ToBillEvent } from '../../../models/Factura';
import { FiscalpopProfile, ProfileQL } from '../../../models/Profile';
import { mesesFormat } from '../../../utils/formatting';
import { DAY_IN_MS, FechaOptions } from '../constants/factura.options';

type BillProperty = 'receptor' | 'conceptos' | 'cfdiRelacionados' | 'comprobante' | 'global' | '_replace';

export function billReducer(state: Bill, { property, value }: { property: BillProperty, value: any }): Bill {
    if (property === 'receptor') {
        return Object.assign({}, state, { receptor: value });
    } else if (property === 'conceptos') {
        return Object.assign({}, state, { conceptos: value });
    }
    else if (property === 'comprobante') {
        return Object.assign({}, state, value);
    }
    else if (property === 'cfdiRelacionados') {
        return Object.assign({}, state, { cfdiRelacionados: value });
    }
    else if (property === 'global') {
        return Object.assign({}, state, { global: value, metodoPago: 'PUE', formaPago: '03' });
    }
    else if (property === '_replace') {
        return Object.assign({}, state, value);
    }
    else {
        // Force update only
        return Object.assign({}, state);
    }
}

/** Blank CFDI used both to start the form and to clear it */
export const EMPTY_BILL = (): Bill => ({
    formaPago: '03',
    metodoPago: 'PUE',
    serie: 'A',
    folio: '1',
    receptor: { nombre: '', rfc: '', usoCFDI: 'G03', email: '', regimen: '612', zip: '' },
    conceptos: [{
        claveProdServ: '',
        claveUnidad: '',
        cantidad: 1,
        descripcion: '',
        valorUnitario: 0,
        descuento: 0,
        pedimento: [],
        noIdentificacion: '',
        impuestos: [{ type: 'iva', tipo: 'Fijo', retencion: false, tasa: 0.16 }]
    }],
} as Bill);

export const EMPTY_BILL_ARGUMENTS = (): ToBillArguments<ToBillEvent> => ({
    timeDefered: 0,
    multipayType: 0,
    multiPayments: 1,
    upfront: 0,
    frequency: 'monthly',
    isClosed: false,
    createdAt: Date.now(),
    billEvents: [],
    paymentEvents: []
});

/**
 * Used for CFDI recovery that might get polluted by "null"
 */
export function cfdiCleaner(cfdiRecovered: Bill, fpProfile: FiscalpopProfile, fechaOptions: FechaOptions) {
    if (!cfdiRecovered.lugarExpedicion) {
        cfdiRecovered.lugarExpedicion = fpProfile.lugarExpedicion;
    }
    if (!cfdiRecovered.fecha) {
        cfdiRecovered.fecha = '';
    } else {
        // Re-set fecha to valid format for selectors
        const msAgo = Date.now() - new Date(cfdiRecovered.fecha).getTime();
        const daysAgoIndex = Math.round(msAgo / DAY_IN_MS);
        cfdiRecovered.fecha = fechaOptions[daysAgoIndex] ? fechaOptions[daysAgoIndex].value : '';
    }
    if (!cfdiRecovered.tipoDeComprobante) {
        delete cfdiRecovered.tipoDeComprobante;
    }
    return cfdiRecovered;
}

/**
 * Forces the fields a "Factura Global" requires over the generic RFC comprobante
 */
export function applyGlobalBillDefaults(cfdi: Bill, currentUser: ProfileQL): Bill {
    const comprobante: Bill = Object.assign({}, cfdi);
    comprobante.receptor.nombre = 'PUBLICO EN GENERAL';
    comprobante.receptor.usoCFDI = 'S01';
    comprobante.receptor.email = currentUser.professionalProfile.email;
    comprobante.receptor.zip = currentUser.fiscalpopProfile.lugarExpedicion;

    comprobante.global = {
        ano: `${new Date().getFullYear()}`,
        mes: mesesFormat(`${new Date().getMonth() + 1}`),
        periodo: '01'
    };
    comprobante.metodoPago = 'PUE';
    comprobante.conceptos.forEach((c) => {
        c.descripcion = 'Venta';
        c.claveProdServ = '01010101';
        c.claveUnidad = 'ACT';
        c.cantidad = 1;
    });
    return comprobante;
}
